import React from "react";
import { AlertTriangle, ArrowRightLeft, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const actionLabels = {
  created: { label: "Crear", variant: "default" },
  updated: { label: "Actualizar", variant: "secondary" },
};

export function TransferPreviewDialog({ open, onOpenChange, preview, executing, onConfirm }) {
  if (!preview) return null;

  const { items = [], total = 0, toCreate = 0, toUpdate = 0, withWarnings = 0 } = preview;
  const seasonName = items[0]?.seasonName || "";
  const tagName = items[0]?.tagName || "";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ArrowRightLeft className="h-5 w-5" />
            Informe previo de traspaso
          </DialogTitle>
          <DialogDescription>
            Revisa el resumen antes de confirmar. Esta accion escribe en el catalogo comercial (products).
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          <div className="rounded-md border bg-gray-50 p-3 text-center">
            <p className="text-2xl font-semibold">{total}</p>
            <p className="text-xs text-gray-600">Total</p>
          </div>
          <div className="rounded-md border bg-green-50 p-3 text-center">
            <p className="text-2xl font-semibold text-green-700">{toCreate}</p>
            <p className="text-xs text-gray-600">Se crearan</p>
          </div>
          <div className="rounded-md border bg-blue-50 p-3 text-center">
            <p className="text-2xl font-semibold text-blue-700">{toUpdate}</p>
            <p className="text-xs text-gray-600">Se actualizaran</p>
          </div>
          <div className="rounded-md border bg-amber-50 p-3 text-center">
            <p className="text-2xl font-semibold text-amber-700">{withWarnings}</p>
            <p className="text-xs text-gray-600">Con avisos</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 text-sm">
          <Badge variant="outline">
            Temporada destino: <span className="ml-1 font-semibold">{seasonName || "(sin cambiar)"}</span>
          </Badge>
          <Badge variant="outline">
            Tag destino: <span className="ml-1 font-semibold">{tagName || "(no se modifican)"}</span>
          </Badge>
        </div>

        <div className="max-h-[45vh] overflow-auto rounded-md border">
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-gray-100 text-left text-xs uppercase text-gray-600">
              <tr>
                <th className="px-3 py-2">Codigo</th>
                <th className="px-3 py-2">Descripcion</th>
                <th className="px-3 py-2">Accion</th>
                <th className="px-3 py-2 text-right">Precio</th>
                <th className="px-3 py-2">Avisos</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => {
                const action = actionLabels[item.action] || actionLabels.created;
                return (
                  <tr key={item.id} className="border-t">
                    <td className="px-3 py-2 font-mono">{item.code}</td>
                    <td className="px-3 py-2">{item.description}</td>
                    <td className="px-3 py-2">
                      <Badge variant={action.variant}>{action.label}</Badge>
                    </td>
                    <td className="px-3 py-2 text-right">{item.precio_v.toFixed(2)} €</td>
                    <td className="px-3 py-2">
                      {item.warnings.length > 0 ? (
                        <span className="inline-flex items-center gap-1 text-amber-700">
                          <AlertTriangle className="h-3.5 w-3.5" />
                          {item.warnings.join(", ")}
                        </span>
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={executing}>
            Cancelar
          </Button>
          <Button type="button" onClick={onConfirm} disabled={executing || total === 0}>
            {executing ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Traspasando...
              </>
            ) : (
              <>
                <ArrowRightLeft className="mr-2 h-4 w-4" />
                Confirmar traspaso ({total})
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
